import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class PackageSelectComponent implements IController {

  selectedId: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  public selectedPackage: any;
  public selectedText: any;
  public sitePackageItems: any;

  constructor(private $mdPanel, private splitService) {
    this.sitePackageItems = this.splitService.getSitePackageItems();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'package';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({package: undefined, id: undefined});
        } else {
          const packageItem = _.find(this.options, (o) => {
            return o.id === selectedId;
          })
          this.onChange({package: packageItem, id: selectedId});
        }

        panel.destroy();

      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({package: undefined, id: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      this.selectedPackage = _.find(this.sitePackageItems, (o) => {
        return o.id === this.selectedId;
      });
      this._setSelectedText();
    } else {
      this.selectedPackage = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedPackage, 'name', '');
  }


}

angular
  .module('bringoz.admin.commons')
  .component('packageSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./package-select.html').default,
    controller: PackageSelectComponent
  });
